import _extends from 'babel-runtime/helpers/extends';

import { previewMixin } from '../mixin/preview.js';
import { mapState } from 'vuex';

export default {
  mixins: [previewMixin],

  computed: _extends({}, mapState({
    templateState: function templateState(state) {
      return state.creative.template.templateState;
    }
  }), {
    buttonAttrs: function buttonAttrs() {
      return {
        disabled: this.templateState === 'saving' || this.preparingPreview,
        text: this.$t('playTurbo.custom.previewer.title'),
        class: 'preview-button'
      };
    }
  }),

  methods: {
    handleClick: function handleClick() {
      this.preview();
      this.navigateToStartScene();
    }
  }
};